<template>
	<div class="allConent">
		<my-header id="head"></my-header>
		<div ref="allHeight"><router-view></router-view></div>
		
		<my-footer></my-footer>
		<toTop id="toTop">
			<template v-slot:one>
				<div class="dialog" @click="centerDialogVisible = true">
					<img src="../../public/images/home/message.png" alt="" />
					<span>在线留言</span>
				</div>
			</template>
			<template v-slot:two>
				<div class="dialog" @click="TopClick">
					<img src="../../public/images/home/top.png" alt="" />
					<span>返回顶部</span>
				</div>
			</template>
		</toTop>
		<!-- <button>777777777</button> -->
		<el-dialog title="在线留言" :visible.sync="centerDialogVisible" width="72%" center>
			<leave-message></leave-message>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="centerDialogVisible = false">提 交</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import myHeader from '@/components/Header.vue';
	import myFooter from '@/components/Footer.vue';
	import toTop from '@/components/toTop.vue';
	import leaveMessage from '@/components/leave_message.vue';
	export default {
		components: {
			myHeader,
			myFooter,
			toTop,
			leaveMessage
		},
		data() {
			return {
				centerDialogVisible: false
			};
		},
		mounted: function() {
			window.addEventListener('scroll', this.handleScroll);
		},
		methods: {
			TopClick(){
				document.documentElement.scrollTop = document.body.scrollTop = 0;
				
			},
			handleScroll() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// let height = this.$refs.scroll.offsetHeight
				if (scrollTop > 0) {
					//滚动大于0的时候要做的操作
					this.$bus.$emit('getBus', 'scroll');
				}
			}
		},
		destroyed() {
			document.removeEventListener('scroll', this.handleScroll);
		}
		// destroyed() {
		// 	document.removeEventListener('scroll', this.handleScroll);
		// }
	};
</script>

<style>
	.allConent{
		background: #f7faff;
	}
	#head {
		z-index: 104;
	}
	#toTop {
		position: fixed;
		right: 0;
		bottom: 100px;
		z-index: 100;
	}
	#toTop .dialog {
		/* border:1px solid red; */
		padding: 8px 0;
	}
	#toTop .dialog > img {
		width: 22px;
		height: 20px;
	}
	#toTop .dialog > span {
		display: block;
		font-size: 12px;
		color: #f5fbff;
		text-align: center;
		margin-top: 4px;
	}
	.el-dialog {
		padding: 20px 80px;
		/* font-size:32px; */
	}
</style>
